export default "__VITE_ASSET__CQCPWzOV__"